<template>
    <label>
        <input
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
            type="checkbox"
            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded mr-1"
        />
        <slot></slot>
    </label>
</template>

<script>
export default {
    name: 'FormCheckbox',
    props: ['modelValue'],
    emits: ['update:modelValue'],
};
</script>
